import React, { ReactElement } from "react";

import CheckPermissions from "../../CheckPermissions";

import { COMPONENTS } from "@utils/Constants";

const loadAncillaryDefinitions = () => import("@workflows/ancillaries/definitions");

export const AncillaryDefinitionsLayoutLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { AncillaryDefinitionsLayout } = await loadAncillaryDefinitions();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_DEFINITIONS}>
      <AncillaryDefinitionsLayout />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const AncillaryDefinitionsLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: AncillaryDefinitions } = await loadAncillaryDefinitions();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_DEFINITIONS}>
      <AncillaryDefinitions tab={0} />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const AncillaryDefinitionsJourneyLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: AncillaryDefinitions } = await loadAncillaryDefinitions();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_DEFINITIONS}>
      <AncillaryDefinitions tab={0} />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const AncillaryDefinitionsSegmentLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: AncillaryDefinitions } = await loadAncillaryDefinitions();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_DEFINITIONS}>
      <AncillaryDefinitions tab={1} />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const AncillaryDefinitionsOthersLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: AncillaryDefinitions } = await loadAncillaryDefinitions();
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_DEFINITIONS}>
      <AncillaryDefinitions tab={2} />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};
